import type { AdminProfile } from "../../types";

export function isAdminProfile(profile: unknown): profile is AdminProfile {
  return typeof profile === "object" && profile !== null && "user_type" in profile;
}

export function isCseProfile(profile: unknown): profile is AdminProfile {
  return (
    typeof profile === "object" &&
    profile !== null &&
    "user_type" in profile &&
    profile.user_type === "CSE"
  );
}
